import { GlButton, GlIcon, GlLink, GlTooltipDirective } from '@gitlab/ui';
import { sprintf, __, s__ } from '~/locale';
import { TIERS } from './constants';
export default {
    name: 'FeatureLibraryItem',
    components: {
        GlButton,
        GlIcon,
        GlLink
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    i18n: {
        pinLabel: s__('FeatureLibrary|Pin %{title}'),
        unpinLabel: s__('FeatureLibrary|Unpin %{title}'),
        pinTooltip: s__('FeatureLibrary|Pin'),
        unpinTooltip: s__('FeatureLibrary|Unpin')
    },
    props: {
        supportsPins: {
            type: Boolean,
            required: false,
            default: false
        },
        item: {
            type: Object,
            required: true
        },
        pinned: {
            type: Boolean,
            required: false,
            default: false
        },
        solidBackground: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'pin-toggle',
        'navigate'
    ],
    computed: {
        tierLabel () {
            switch(this.item.tier){
                case TIERS.PREMIUM:
                    return __('Premium');
                case TIERS.ULTIMATE:
                    return __('Ultimate');
                case TIERS.ADD_ON:
                    return __('Add-on');
                default:
                    return __('Free');
            }
        },
        pinAriaLabel () {
            const template = this.pinned ? this.$options.i18n.unpinLabel : this.$options.i18n.pinLabel;
            return sprintf(template, {
                title: this.item.title
            });
        },
        pinIconName () {
            return this.pinned ? 'thumbtack-solid' : 'thumbtack';
        },
        pinTooltipText () {
            return this.pinned ? this.$options.i18n.unpinTooltip : this.$options.i18n.pinTooltip;
        }
    },
    methods: {
        onPinClick () {
            this.$emit('pin-toggle', this.item.id, !this.pinned, this.item.title);
        },
        onNavigate () {
            this.$emit('navigate', this.item.id);
        },
        // eslint-disable-next-line vue/no-unused-properties -- invoked externally via this.$refs.searchResultItems in feature_library_modal.vue
        focus () {
            this.$refs.titleLink?.$el?.focus();
        }
    }
};
